import { redirectIfIsNotInitialized } from '../../../Components/RedirectPlayer/RedirectPlayer';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IState, actions } from '../../../Store/reducer';
import { INDEX_PLAYER_PATH, PV_PLAYER_PATH } from '../../../Services/routeNames';
import { useNavigate } from 'react-router-dom';
import HeaderLayout from '../../../Layout/HeaderLayout';
import levels from '../../../Services/levels';
import species from '../../../Services/species';
import archetypes from '../../../Services/archetypes';

import './ConfigurationPlayer.scss';

function ConfigurationPlayer() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { characterInfo } = useSelector((state: IState) => state.player);

    useEffect(() => {
        redirectIfIsNotInitialized(characterInfo.species, INDEX_PLAYER_PATH, navigate);
    }, [navigate, characterInfo.species]);

    function setLevel(level: number) {
        const hp = getHpMax(level);

        dispatch({
            type: actions.player.SET_LEVEL,
            payload: {
                player: {
                    level: level,
                    hpMax: hp,
                    currentHp: hp,
                }
            },
        });
        navigate(PV_PLAYER_PATH);
    }

    function getHpMax(newLevel: number): number {
        if (newLevel !== -1) {
            let speciesHp: number = 0;
            let archetypeHp: number = 0;

            if (characterInfo.species) {
                speciesHp = species[characterInfo.species].hp[newLevel];
            }

            if (characterInfo.archetype) {
                archetypeHp = archetypes[characterInfo.archetype].hp[newLevel];
            }

            return speciesHp + archetypeHp;
        }
        return -1;
    }

    return (
        <div className="player-configuration">
            <HeaderLayout currentPage="customization" hamburger={true} isPlayer={true}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.99 100"><g fill="white"><path d="m98.69,13.69l-.33-.9-12,12-11.42.28.28-11.42,12-12-.9-.33c-2.34-.87-4.79-1.31-7.28-1.31-5.42,0-10.51,2.09-14.3,5.89-5.83,5.83-7.5,14.82-4.21,22.52-.58.46-1.12.94-1.61,1.42L14.62,74.13c-4-.5-7.98.86-10.81,3.69-2.45,2.45-3.81,5.72-3.81,9.19s1.35,6.73,3.81,9.19,5.72,3.81,9.19,3.81,6.73-1.35,9.19-3.81c2.86-2.87,4.2-6.79,3.69-10.81l44.3-44.3c.49-.5.97-1.03,1.42-1.6,2.59,1.1,5.41,1.69,8.21,1.69h0c5.42,0,10.5-2.09,14.3-5.89,5.58-5.58,7.38-14.05,4.58-21.58ZM17.66,91.67c-1.25,1.25-2.9,1.93-4.67,1.93s-3.42-.69-4.67-1.93c-1.25-1.25-1.93-2.91-1.93-4.67s.69-3.42,1.93-4.67c1.25-1.25,2.9-1.93,4.67-1.93s3.42.69,4.67,1.93c2.57,2.57,2.57,6.76,0,9.34Z" /></g></svg>
                <span>Configuration</span>
            </HeaderLayout>

            <div className="level-list">
                {levels.map((level, index) =>
                    <div key={level} className="level" onClick={() => setLevel(index)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 977 125.52"><g fill="#ec672a"><path d="m973.98,0l-.45,42.44-165.87,3.25,166.83.54.03,2.57,2.47,41.15c.09,1.47-.77,2.79-1.98,3.96l.35,31.62-948.87-2.85,347.64-12.87L4.01,117.54,0,50.92c-.09-1.43.72-2.71,1.87-3.85L1.43,6.99,973.98,0Z" /></g></svg>
                        <span>{level}</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ConfigurationPlayer;